<template>
  <div class="tasks-order-row" :style="{'border-left-color': task.highlightColour}">
    <div class="tasks-order-main">
      <div class="tasks-order-labels-area float-right">
        <ExpandCollapseButton v-model="expanded" />
      </div>
      <Drop :acceptsType="['task-manager-order', 'task-manager-order-item']" class="droppable-item" @drop="onTaskItemDropped(task, $event)">
        <h4 class="tasks-order-title">{{task.name}}</h4>
      </Drop>
      <div class="pl-2">
        <p class="text-muted">
          <i class="far fa-fw fa-clipboard-list-check"></i>&nbsp;<a href="#" @click.prevent="onEditTaskClicked(task)">{{task.sequenceNumber}}</a>
        </p>
        <p class="text-muted" v-if="task.description">
          <i class="far fa-fw fa-sticky-note"></i>&nbsp;{{task.description}}
        </p>
        <p class="text-muted">
          <i class="far fa-fw fa-clock"></i>&nbsp;{{task.scheduleStartDate | formatDateTime}}
        </p>
        <p class="text-muted" v-if="hasResources">
          <i class="far fa-fw fa-user-circle"></i>&nbsp;{{taskResourceDescription}}
        </p>

        <div class="my-2" v-show="hasTaskItems && expanded">
          <strong>Task Items</strong>
          <div class="mb-1 pl-1">
            <p v-for="taskItem of task.taskItems" :key="taskItem.id">
              <i class="fas fa-caret-right mr-1"></i>
              <LabelBadge :labelClass="`label-taskitem-status-${taskItem.status}`">{{taskItem.status | formatLookupName(TaskStatusTypeLookup)}}</LabelBadge>
              <span class="ml-1">
                {{taskItem.name}}
              </span>
            </p>
          </div>
        </div>

        <div class="tasks-order-labels-area">
          &nbsp;
          <div class="float-right">
            <LabelBadge :labelClass="`label-task-status-${task.status}`">{{task.status | formatLookupName(TaskStatusTypeLookup)}}</LabelBadge>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.resource-task-list .resource-task:not(last-child) {
  margin-bottom: 1.0rem;
}
.resource-task {
  padding-left: 0.75rem;
}
.resource-task-container {
  padding: 0.15rem;
}
.resource-task-details {
  padding-left: 0.75rem;
}
.resource-task-item {
  padding-left: 0.75rem;
  padding-bottom: 2px;
}
.resource-order-item {
  padding: 1px 0 0.1rem 0.75rem;
}
</style>

<script>
import _ from 'lodash'
import { Drop } from 'vue-easy-dnd'

import TaskManagerMixin from '@/modules/tasks/mixins/taskManagerMixin'

import { TaskStatusTypeLookup } from '@/store/types'

export default {
  name: 'TaskManagerTaskPanel',
  components: {
    Drop
  },
  mixins: [TaskManagerMixin],
  props: {
    task: Object
  },
  computed: {
    hasTaskItems() {
      if(!this.task)
        return false
      if(this.task.taskItems && this.task.taskItems.length > 0)
        return true
      return false
    },
    hasResources() {
      if(!this.task)
        return false
      if(this.task.resources && this.task.resources.length > 0)
        return true
      return false
    },
    taskResourceDescription() {
      if(this.task && this.task.resources) {
        return this.task.resources.map(resource => resource.name).join(' / ')
      }
      return ''
    }
  },
  watch: {
    
  },
  data() {
    return {
      expanded: false,
    }
  },
  created() {
    this.TaskStatusTypeLookup = TaskStatusTypeLookup
  },
  methods: {
    onTaskItemDropped(task, data) {
      var dropData = {
        orderId: data.data.orderId,
        orderItemId: data.data.orderItemId,
        taskId: task.id
      }

      this.$emit('orderDroppedOnTask', dropData)
    },
    onEditTaskClicked(task) {
      this.$emit('editTask', task)
    }
  }
}
</script>